import React from 'react';
import styles from './PageErrorBoundary.module.css';

class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('PageErrorBoundary caught an error:', error, errorInfo);
  }

  handleRetry() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      const error = this.state.error;
      const details = error?.details || error?.response?.data || null;

      return (
        <div className={styles.container}>
          <h2 className={styles.title}>Something went wrong on this page</h2>
          <p className={styles.message}>
            {error?.message || 'An unexpected error occurred.'}
          </p>

          {details && (
            <details className={styles.details}>
              <summary>Error details</summary>
              <pre className={styles.detailsPre}>
                {typeof details === 'string'
                  ? details
                  : JSON.stringify(details, null, 2)}
              </pre>
            </details>
          )}

          <div className={styles.actions}>
            <button className={styles.retryButton} onClick={this.handleRetry}>
              Try Again
            </button>
            <button
              className={styles.reloadButton}
              onClick={() => window.location.reload()}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default PageErrorBoundary;
